/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/
export default function themeTypography(theme) {
    return {
        fontFamily: theme?.customization?.fontFamily,
        h6: {
            color: theme.heading,
            fontSize: '0.75rem',
            lineHeight: '1.334em'

        },
        h5: {
            fontSize: '0.875rem',
            color: theme.heading,
            lineHeight: '1.334em'

        },
        h4: {
            fontSize: '1rem',
            color: theme.heading,
            lineHeight: '1.334em'

        },
        h3: {
            fontSize: '1.25rem',
            color: theme.heading,
            lineHeight: '1.334em'

        },
        h2: {
            fontSize: '1.5rem',
            color: theme.heading,
            lineHeight: '1.334em'

        },
        h1: {
            fontSize: '2.125rem',
            color: theme.heading,
            lineHeight: '1.334em'

        },
        subtitle1: {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: theme?.customization?.mode === 'dark' ? theme.heading : theme.textDark
        },
        subtitle2: {
            fontSize: '0.75rem',
            fontWeight: 500,
            color: theme.darkTextSecondary
        },
        caption: {
            fontSize: '0.75rem',
            color: theme.darkTextSecondary,
            fontWeight: 500
        },
        body1: {
            fontSize: '0.95rem',
            fontWeight: 400,
            lineHeight: '1.334em'
        },
        body2: {
            letterSpacing: '0em',
            fontWeight: 400,
            lineHeight: '1.5em',
            color: theme.darkTextPrimary
        },
        customInput: {
            marginTop: 8,
            marginBottom: 8,
            fontSize: '15px',
            '& > label': {
                top: '13px',
                left: 0,
                color: theme.grey500,
                '&[data-shrink="false"]': {
                    top: '5px'
                }
            },
            '& > div > input': {
                padding: '30.5px 14px 11.5px !important'
            },
            '& legend': {
                display: 'none'
            },
            '& fieldset': {
                top: 0
            }
        },
    
      
    };
}
